import React from 'react'

// Hooks
import { useGlobal } from '../../../../../hooks'

import { AdministrationList } from '../../../List'

// Queries
import { DELETE_SITES, LIST_SITES } from './queries'

const table = [
  { th: 'ID', td: 'id' },
  { th: 'Cliente', td: ['client', 'name'] },
  { th: 'Descripción', td: 'name' },
]

const queries = { list: LIST_SITES, delete: DELETE_SITES }

const AdministrationListClientSites = () => {
  const [{ me }] = useGlobal()

  const no = ![1, 2].includes(me.id_role)

  return (
    <AdministrationList
      table={table}
      queries={queries}
      noCreate={no}
      noUpdate={no}
      noDelete={no}
    />
  )
}

export default AdministrationListClientSites
